import React from 'react';
import PropTypes from 'prop-types';
import { ARRAY_OF_NAME_LABEL_PROP_TYPE } from 'shared/constants/PropTypes';
import TTSelectField from '../../../ttSelectField/TTSelectField';

class TTSourceColumns extends React.Component {
  constructor(props) {
    super(props);
    this.state = { selectedValue: props.value || '' };
  }

  handleSelectChange = (event, key, currentValue) => {
    this.setState({ selectedValue: currentValue });
    this.props.onValueChange(this.props.sourceColumnId, currentValue);
  };

  render() {
    const { sourceFields, disabled } = this.props;
    return (
      <div>
        <TTSelectField
          defaultLabel={ 'Input Data Columns' }
          value={ this.state.selectedValue }
          onValueChange={ this.handleSelectChange }
          items={ sourceFields }
          disabled={ disabled }
        />
      </div>
    );
  }
}

TTSourceColumns.propTypes = {
  sourceColumnId: PropTypes.number.isRequired,
  sourceFields: ARRAY_OF_NAME_LABEL_PROP_TYPE.isRequired,
  onValueChange: PropTypes.func,
  value: PropTypes.string,
  disabled: PropTypes.bool
};

TTSourceColumns.defaultProps = {
  onValueChange: () => null,
  disabled: false
};

export default TTSourceColumns;



// WEBPACK FOOTER //
// ./src/shared/components/translationTable/c/ttColumnManager/c/ttSourceColumn/TTSourceColumn.js